import { render } from "./debug-settings-menu.vue?vue&type=template&id=f0f415dc"
import script from "./debug-settings-menu.vue?vue&type=script&lang=ts"
export * from "./debug-settings-menu.vue?vue&type=script&lang=ts"
script.render = render

export default script